// Centralized data-testid registry
export const TID = {
  login: {
    emailInput: "login-email-input",
    passwordInput: "login-password-input",
    submit: "login-submit-button",
    demoUser: (role) => `login-demo-${role}`,
    error: "login-error",
  },
  shell: {
    sidebar: "app-sidebar",
    sidebarItem: (key) => `sidebar-item-${key}`,
    sidebarToggle: "sidebar-toggle",
    header: "app-header",
    fySelect: "fy-selector",
    notifBell: "notif-bell",
    notifBadge: "notif-badge",
    userMenu: "user-menu",
    logoutBtn: "logout-button",
  },
  dashboard: {
    statCard: (key) => `stat-card-${key}`,
    donutCompletion: "chart-donut-completion",
    lineMonthly: "chart-line-monthly",
    barCategory: "chart-bar-category",
    donutGrade: "chart-donut-grade",
    topSuppliers: "table-top-suppliers",
    upcoming: "table-upcoming",
    myAssignments: "table-my-assignments",
  },
  suppliers: {
    createBtn: "supplier-create-button",
    row: (id) => `supplier-row-${id}`,
    editBtn: (id) => `supplier-edit-${id}`,
    deleteBtn: (id) => `supplier-delete-${id}`,
    saveBtn: "supplier-save-button",
  },
  plants: {
    createBtn: "plant-create-button",
    saveBtn: "plant-save-button",
  },
  users: {
    createBtn: "user-create-button",
    saveBtn: "user-save-button",
  },
  categories: {
    createBtn: "category-create-button",
    saveBtn: "category-save-button",
  },
  questions: {
    createBtn: "question-create-button",
    saveBtn: "question-save-button",
  },
  planning: {
    createBtn: "planning-create-button",
    saveBtn: "planning-save-button",
    assignBtn: (id) => `planning-assign-${id}`,
    editBtn: (id) => `planning-edit-${id}`,
    deleteBtn: (id) => `planning-delete-${id}`,
  },
  audit: {
    startBtn: (id) => `audit-start-${id}`,
    submitBtn: "audit-submit-button",
    uploadInput: "audit-upload-input",
    findingAddBtn: "audit-finding-add-button",
    scoreInput: (qid) => `audit-score-${qid}`,
    remarkInput: (qid) => `audit-remark-${qid}`,
  },
  review: {
    approveBtn: "review-approve-button",
    rejectBtn: "review-reject-button",
    commandBtn: "review-command-button",
  },
  capa: {
    createBtn: "capa-create-button",
    verifyBtn: (id) => `capa-verify-${id}`,
  },
  reports: {
    exportPdfBtn: (id) => `report-export-${id}`,
  },
};
